import { useContext } from 'react';
import { LoanTypesContext } from '../contexts/LoanTypesContext';

const useLoanTypes = () => useContext(LoanTypesContext);

export default useLoanTypes;
